import { rem } from "./auth-service-tools172.js";
import "react";
import "./auth-service-tools177.js";

function sizeResolver(value) {
  if (typeof value === "number") {
    return rem(value);
  }

  return value;
}

export { sizeResolver };